module.exports = __webpack_public_path__ + "img/arrow-left-icon.6de719fd.png";